import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { getCashImage } from "constants/cash";
import { GAME_STATES } from "constants/constants";
import styles from "./CashRain.module.scss";

export default function CashRain({ className, active, slotIdx, slotCount, cashMatrix, gameState, maxPerPlayer = 10, durationMs = 3000, maxDelayMs = 300, ...rest })
{
    const notes = useMemo(() => {
        if (!active) return [];

        const out = [];
        const stacksInSlot = cashMatrix?.[slotIdx] ?? [];

        stacksInSlot.forEach((stackData, stackIndex) => {
            const targetCount = Math.min(Math.max(0, stackData.count), maxPerPlayer);
            if (targetCount <= 0) return;

            const colorKey = stackData.color;
            const img = getCashImage(colorKey, slotCount, 3, gameState === GAME_STATES.REVEAL);

            for (let i = 0; i < targetCount; i++) {
                out.push({
                    key: `rain-${slotIdx}-${stackIndex}-${i}`, src: img, xPosPercent: Math.random() * 100,
                    delayMs: Math.random() * maxDelayMs, scale: 0.45 + Math.random() * 0.25,
                });
            }
        });

        return out;
    }, [active, cashMatrix, slotIdx, slotCount, gameState, maxPerPlayer, maxDelayMs]);

    if (!active || notes.length === 0) return null;

    return (
        <div className={className || ""} {...rest}>
            {notes.map(n => (
                <img key={n.key} src={n.src} alt="" aria-hidden="true" className={styles.note}
                    style={{
                        left: `${n.xPosPercent}%`,
                        animationDuration: `${durationMs}ms`,
                        animationDelay: `${n.delayMs}ms`,
                        transform: `translate(-50%, -160%) scale(${n.scale})`
                    }}
                />
            ))}
        </div>
    );
}

CashRain.propTypes = {
    className: PropTypes.string,
    active: PropTypes.bool.isRequired,
    slotIdx: PropTypes.number.isRequired,
    slotCount: PropTypes.number.isRequired,
    cashMatrix: PropTypes.arrayOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                color: PropTypes.string,
                count: PropTypes.number.isRequired,
            })
        )
    ).isRequired,
    gameState: PropTypes.any,
    maxPerPlayer: PropTypes.number,
    durationMs: PropTypes.number,
    maxDelayMs: PropTypes.number,
};